import { connectAuthEmulator, getAuth } from "firebase/auth"
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore"

// Add other emulators here if you use them, e.g., connectStorageEmulator, getStorage

export default defineNuxtPlugin(() => {
	const config = useRuntimeConfig()

	const authEmulatorHost = config.public.FIREBASE_AUTH_EMULATOR_HOST
	const firestoreEmulatorHost = config.public.FIREBASE_FIRESTORE_EMULATOR_HOST
	if (authEmulatorHost || firestoreEmulatorHost) {
		console.log("Connecting to Firebase emulators...")

		console.log("Auth Emulator host from runtimeConfig:", authEmulatorHost)
		if (authEmulatorHost) {
			const [host, port] = authEmulatorHost.split(":")
			console.log(`Manually connecting Auth to emulator at http://${host}:${port}`)
			connectAuthEmulator(getAuth(), `http://${host}:${port}`)
		}

		console.log("Firestore Emulator host from runtimeConfig:", firestoreEmulatorHost)
		if (firestoreEmulatorHost) {
			const [host, port] = firestoreEmulatorHost.split(":")
			console.log(`Manually connecting Firestore to emulator at http://${host}:${port}`)
			connectFirestoreEmulator(getFirestore(), host, parseInt(port))
		}
	}
	// console.log("zzzzzzzzzzzzzzzzzzzzzzzzz")

	//
	// getSetPathPar(LangsStore.context, "lang_id", "", "/" + LangsStore.context.lang_id)
	// router.push({ path: "/" + LangsStore.context.lang_id}))
})
